import { PipeTransform, Pipe } from "@angular/core"
import { IProduct } from "graphql/queries/keyword.queries"

@Pipe({
  name: 'filterContents'
})

export class FilterContents implements PipeTransform {
  transform(value: IProduct[], filterStr: string): any[] {
    if (!filterStr) return value

    filterStr = this.normalizeString(filterStr)
    return value.filter(product => this.normalizeString(product.name).includes(filterStr))
  }

  normalizeString(str: string): string {
    return str.toLowerCase().replace(/,/g, '')
  }
}
